import React from "react";
import { Container } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import "./Last.css";

const Last = () => {
  const faqData = [
    {
      id: 0,
      question: "What platforms do you build apps for?",
      answer:
        "We are experts in building high-quality apps for both major mobile platforms - iOS and Android. We can build native & hybrid apps tailored specifically for each operating system, and cross-platform apps using tools like React Native, Flutter, and more.",
    },
    {
      id: 1,
      question: "What industries have you built apps for?",
      answer:
        "We have extensive experience building successful apps across health & fitness, e-commerce, fintech, travel, logistics, and more. We have 90% of client retention and our past clients include enterprises, SMEs, and startups.",
    },
    {
      id: 2,
      question: "What is the mobile app development process like?",
      answer:
        "When we offer our mobile app development service, we use the agile software development method, it is the best development method in the market and allows us to focus on iterating based on user feedback for continuous improvement.",
    },
    {
      id: 3,
      question: "Do you offer post-launch support and maintenance?",
      answer:
        "Yes, we offer comprehensive support after launch including fixes, updates, and maintenance to give your app longevity. We become your extended in-house team.",
    },
    {
      id: 4,
      question: "Why should I hire your company over freelancers?",
      answer:
        "We are a full-service mobile app agency with a team of specialists in strategy, design, development, and marketing. This ensures expertise, accountability, project management, and reduced risk compared to individual freelancers.",
    },
    {
      id: 5,
      question: "How much does it cost to build a mobile app?",
      answer:
        "The cost depends on the complexity of features, UI/UX design needs, development time required, and post-launch support. For a more accurate estimate tailored to your specific requirements, we provide customized quotes.",
    },
  ];
  return (
    <>
      <section className="last-mobileApp-section">
        <Container>
          <div className="top-text-after-last-mobileApp">
            <h2>
              QUESTIONS <span>YOU'D LIKE TO ASK</span>
            </h2>
          </div>
          <Accordion defaultActiveKey="0">
            {faqData?.map(({ id, question, answer }) => (
              <Accordion.Item key={id} eventKey={id.toString()}>
                <Accordion.Header>{`${id + 1}. ${question}`}</Accordion.Header>
                <Accordion.Body>{answer}</Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </Container>
      </section>
    </>
  );
};

export default Last;
